<template>
  <div class="popup" v-if="isShowing">
    <div class="popup__block" @click.stop v-click-outside="close">
      <primary-button
        class="popup__action"
        @click="selectWidgetType('qr')"
        :text="$t('cart.actions.widget-type.qr')"
      ></primary-button>
      <primary-button
        class="popup__action"
        @click="selectWidgetType('pos')"
        :text="$t('cart.actions.widget-type.pos')"
      ></primary-button>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";

export default {
  name: "SelectWidgetTypePopup",
  components: { PrimaryButton },
  data() {
    return {
      isShowing: false,
    };
  },

  popupController: {},

  mounted() {
    document.addEventListener("keydown", this.handleKeyDown);
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },

  methods: {
    handleKeyDown(e) {
      if (this.isOpen && e.key === "Escape") {
        this.close();
      }
    },

    async open() {
      console.log(document.getElementById("canvasQR"));
      document.body.style.overflow = "hidden";
      this.isShowing = true;

      return new Promise((resolve, reject) => {
        this.$options.popupController = { resolve, reject };
      });
    },
    close() {
      document.body.style.overflow = "auto";

      this.isShowing = false;
      this.$options.popupController.resolve(false);
    },
    selectWidgetType(widgetType) {
      this.isShowing = false;
      document.body.style.overflow = "auto";
      this.$options.popupController.resolve(widgetType);
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 99;

  &__block {
    width: 380px;

    border-radius: 20px;
    background: #ffffff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}

.qr-block {
  width: 300px;
  height: 300px;
}
</style>
